export default __webpack_public_path__ + "static/media/ourclient11.abbdb486.png";